import { FC } from "react";
import { Flex } from "@chakra-ui/react";

import { CloseButton } from "@shared/components";

import { MachineAnalysisPreviewHeader } from "../MachineAnalysisPreview";

interface MachineAnalysisPreviewModalHeaderProps {
  onClose: () => void;
  name: string;
}

const MachineAnalysisPreviewModalHeader: FC<MachineAnalysisPreviewModalHeaderProps> = ({ onClose, name }) => {
  return (
    <Flex px={8} py={3} justifyContent="space-between" alignItems="center">
      <MachineAnalysisPreviewHeader name={name} />
      <CloseButton color="grey.10" onClick={onClose} />
    </Flex>
  );
};

export default MachineAnalysisPreviewModalHeader;
